// LOGIN CONSTANTS
export const LOGIN  = 'App/Auth/LOGIN'
export const LOGIN_RET  = 'App/Auth/LOGIN_RET'
export const LOGIN_LOADING  = 'App/Auth/LOGIN_LOADING'
export const LOGIN_ERROR  = 'App/Auth/LOGIN_ERROR'

// WHOAMI CONSTANTS
export const WHOAMI  = 'App/Auth/WHOAMI'
export const WHOAMI_RET  = 'App/Auth/WHOAMI_RET'
export const WHOAMI_LOADING  = 'App/Auth/WHOAMI_LOADING'
export const WHOAMI_ERROR  = 'App/Auth/WHOAMI_ERROR'

// LOGOUT
export const LOGOUT  = 'App/Auth/LOGOUT'
export const LOGOUT_RET  = 'App/Auth/LOGOUT_RET'
export const LOGOUT_CLR  = 'App/Auth/LOGOUT_CLR'
// REGISTER
export const REGISTER  = 'App/Auth/REGISTER'
export const REGISTER_RET  = 'App/Auth/REGISTER_RET'
export const REGISTER_LOADING  = 'App/Auth/REGISTER_LOADING'
export const REGISTER_ERROR  = 'App/Auth/REGISTER_ERROR'

// DASHBOARD
export const GET_DASH_PATIENTS_DETAILS  = 'App/Auth/GET_DASH_PATIENTS_DETAILS'
export const GET_DASH_PATIENTS_DETAILS_RET  = 'App/Auth/GET_DASH_PATIENTS_DETAILS_RET'
export const GET_DASH_PATIENTS_DETAILS_LOADING  = 'App/Auth/GET_DASH_PATIENTS_DETAILS_LOADING'
export const GET_DASH_PATIENTS_DETAILS_ERROR  = 'App/Auth/GET_DASH_PATIENTS_DETAILS_ERROR'

// PATIENTS
export const GET_PATIENTS_DETAILS  = 'App/Auth/GET_PATIENTS_DETAILS'
export const GET_PATIENTS_DETAILS_RET  = 'App/Auth/GET_PATIENTS_DETAILS_RET'
export const GET_PATIENTS_DETAILS_LOADING  = 'App/Auth/GET_PATIENTS_DETAILS_LOADING'
export const GET_PATIENTS_DETAILS_ERROR  = 'App/Auth/GET_PATIENTS_DETAILS_ERROR'

// PATIENTS
export const GET_BOOKING_AL  = 'App/Auth/GET_BOOKING_AL'
export const GET_BOOKING_AL_RET  = 'App/Auth/GET_BOOKING_AL_RET'
export const GET_BOOKING_AL_LOADING  = 'App/Auth/GET_BOOKING_AL_LOADING'
export const GET_BOOKING_AL_ERROR  = 'App/Auth/GET_BOOKING_AL_ERROR'

// Upload PATIENT Reports
export const UPLOAD_PATIENT_REPORT = 'App/Dashboard/UPLOAD_PATIENT_REPORT'
export const UPLOAD_PATIENT_REPORT_RET = 'App/Dashboard/UPLOAD_PATIENT_REPORT_RET'
export const UPLOAD_PATIENT_REPORT_LOADING = 'App/Dashboard/UPLOAD_PATIENT_REPORT_LOADING'

// Upload PATIENT Reports
export const UPLOAD_PATIENT_INSURANCE = 'App/Dashboard/UPLOAD_PATIENT_INSURANCE'
export const UPLOAD_PATIENT_INSURANCE_RET = 'App/Dashboard/UPLOAD_PATIENT_INSURANCE_RET'
export const UPLOAD_PATIENT_INSURANCE_LOADING = 'App/Dashboard/UPLOAD_PATIENT_INSURANCE_LOADING'

//Update booking
export const UPDATE_BOOKING  = 'App/Auth/UPDATE_BOOKING'
export const UPDATE_BOOKING_RET  = 'App/Auth/UPDATE_BOOKING_RET'
export const UPDATE_BOOKING_LOADING  = 'App/Auth/UPDATE_BOOKING_LOADING'